import React from 'react'
import { connect } from 'react-redux'
import { Editor } from '@tinymce/tinymce-react'
import InsuranceActions from '../../Redux/InsuranceRedux'

class UpdateTravelPackage extends React.Component {
  constructor (props) {
    super(props)
    this.types = [
      {value: 'individu', label: 'Individu'},
      {value: 'family', label: 'Family'}
    ]
    this.destination_types = [
      {value: 'overseas', label: 'Overseas'},
      {value: 'domestic', label: 'Domestic'}
    ]
    this.state = {
      form: {
        name: props.detail.name || '',
        description: props.detail.description || '',
        type: props.detail.type || '',
        destination_type: props.detail.destination_type || ''
      }
    }
  }

  _inputChange = (event, field) => {
    let val = ''
    if (field === 'description') {
      val = event.target.getContent()
    } else {
      val = event.target.value
    }
    let form = {...this.state.form}
    form[field] = val
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = {...this.state.form}
    const data = {
      id: this.props.detail.id,
      form
    }
    this.props.put(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '70vw' }} >
        <div className='title-block'>
          <h4 className='title mr-auto'>Update Travel Package</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Package Name</label>
            </div>
            <div className='col-9'>
              <input type='text' required placeholder='Insert package name here' className='form-control' value={this.state.form.name} onChange={(event) => this._inputChange(event, 'name')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Description</label>
            </div>
            <div className='col-9'>
              <Editor
                initialValue={this.state.form.description}
                init={{
                  plugins: 'table lists textcolor colorpicker',
                  menubar: false,
                  branding: false,
                  toolbar1: 'formatselect fontselect fontsizeselect | bold italic underline | forecolor backcolor',
                  toolbar2: 'alignleft aligncenter alignright | indent outdent | numlist bullist | table',
                  height: 350
                }}
                onChange={(event) => this._inputChange(event, 'description')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Insurance Type</label>
            </div>
            <div className='col-9'>
              <select
                required
                className='form-control'
                value={this.state.form.type}
                onChange={(event) => this._inputChange(event, 'type')}
              >
                <option disabled value=''>Pick a Type</option>
                {
                  this.types.map((item, i) => (
                    <option key={i} value={item.value}>{item.label}</option>
                  ))
                }
              </select>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Destination Type</label>
            </div>
            <div className='col-9'>
              <select
                required
                className='form-control'
                value={this.state.form.destination_type}
                onChange={(event) => this._inputChange(event, 'destination_type')}
              >
                <option disabled value=''>Pick a Destination Type</option>
                {
                  this.destination_types.map((item, i) => (
                    <option key={i} value={item.value}>{item.label}</option>
                  ))
                }
              </select>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  put: (data) => dispatch(InsuranceActions.putTravelPackageRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateTravelPackage)



// WEBPACK FOOTER //
// ./src/Containers/Insurance/UpdateTravelPackage.js